import React, { useState, useEffect } from 'react';

import "../Layout/Layout.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEye, faEyeSlash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  const [surname, setsurname] = useState(''); // họ người dùng 
  const [firstname, setfirstname] = useState(''); // tên người dùng
  const [username, setusername] = useState(); //  họ tên người dùng = surname + firstname
  const [useremail,setuseremail] = useState(''); // gmail người dùng
  const [userphone,setuserphone] = useState(''); // sđt người dùng
  const [password,setpassword] = useState(''); // mật khẩu
  const [Notificationname,setNotificationname] = useState(); // thông báo 
  const [Notificationpassword,setNotificationpassword] = useState();
  const [Notificationphone,setNotificationphone] = useState();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = (event) => {
    setpassword(event.target.value);
    setShowPassword(!showPassword);
  };
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!username) {
  //     setNotificationname('Nhập tên đăng nhập !');
      
  //   } else{
  //     setNotificationname('');
  //   }
  //   if (!password) {
  //     setNotificationpassword('Nhập mật khẩu !');
  //     return;
  //   } else{
  //     setNotificationpassword('');
  //   }
  //   const login = user.find(user => (user.username === username ||user.std === username) && user.password === password );
  //   if (login) {
  //     navigate('/');
  //   } else {
  //     setNotificationname('Tên đăng nhập hoặc mật khẩu không đúng !');
  //   }
  // };
  const [form1 , setform1] = useState(true);
  const [form2 , setform2] = useState(false);
  const [form3 , setform3] = useState(false);
  const [form4 , setform4] = useState(false);
  const onclickform1 = (e) => {
    e.preventDefault();
    if (form3){
      setform3(false);
      setform4(true);
    } else if (form2) {
      setform2(false);
      setform3(true);
    }  else {
      setform1(false);
      setform2(true);
    }
    // e.preventDefault();
    // if(form1){
    //   setform1(false);
    //   setform2(true);
    // }else{
    //   setform1(true);
    //   setform2(false);
    // }
    
  }
  useEffect(() => {
    setusername(`${surname} ${firstname}`);
  }, [surname, firstname]);
  
  const isValidPhoneNumber = (phoneNumber) => {
    // Loại bỏ các ký tự không phải số
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Kiểm tra độ dài và ký tự đầu tiên
    if (cleanedPhoneNumber.length !== 10 || cleanedPhoneNumber[0] !== '0') {
      return false;
    }

    // Kiểm tra số lượng lần lặp liên tiếp của một số
    let maxRepeat = 0;
    let currentRepeat = 1;
    for (let i = 1; i < cleanedPhoneNumber.length; i++) {
      if (cleanedPhoneNumber[i] === cleanedPhoneNumber[i - 1]) {
        currentRepeat++;
        maxRepeat = Math.max(maxRepeat, currentRepeat);
      } else {
        currentRepeat = 1;
      }
    }

    return maxRepeat <= 4;
  };




  return (
    <body class='Desktop'>
      <div class='form-login-logout'>
        <div class='form-login'>
          <h1>ĐĂNG KÝ</h1>
          <div style={{ display: form1 ? 'block' : 'none' }}>
            <div class='form-login-1' style={{display:"flex"}}>
              <div class='button-icon'>
                <p>Facebook</p>
              </div>
              <div class='button-icon'>
                <p>Google</p>
              </div>
            </div>
            <div class='form-login-1'>
              <div class='line-button'>
                <div class='line'></div>
                <p style={{margin:"0"}}>Hoặc</p>
                <div class='line'></div>
              </div>
            </div>
            <form class='form-login-1' >
              <div class='f414'>
                <label class='f414-1' for="surname">Họ </label>
                <div class='f414-2'></div>
                <label class='f414-1' for="firstname">Tên </label>
              </div>
              <div  class='f414'>
                <div class='username f414-1'>
                  <input type="text" name="surname" id="surname" placeholder="" value={surname}  onChange={(e) => setsurname(e.target.value)}></input>
                  <div class='input-icon'>
                    {surname ?
                      (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                      :
                      (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                    }
                  </div>
                </div>
                <div class='f414-2'></div>
                <div class='username f414-1'>
                  <input type="text" name="firstname" id="firstname" placeholder="" value={firstname}  onChange={(e) => setfirstname(e.target.value)}></input>
                  <div class='input-icon'>
                    {firstname ?
                      (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                      :
                      (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                    }
                  </div>
                </div>
              </div>
              <hr></hr>
              <label for="username">Tên Người Dùng </label>
              <div class='username'>
                <input type="text" name="username" id="username" placeholder={surname + firstname}  value={username}  onChange={(e) => setusername(e.target.value)}></input>
                <div class='input-icon'>
                  
                </div>
              </div>
              <div class='line-button'>
                <div class='line'></div>
                <button class='button' onClick={onclickform1}>Tiếp theo</button>
                <div class='line'></div>
              </div>
              <div class='line-button'>
                <div class='line'></div>
                <span style={{backgroundColor:"#fff",color:"#39588A"}}  >1</span>
                <div class='line'></div>
                <span>2</span>
                <div class='line'></div>
                <span>3</span>
                <div class='line'></div>
                <span>4</span>
                <div class='line'></div>
              </div>
            </form>
            
          </div>
          {/* form-2 */}
          <div style={{ display: form2 ? 'block' : 'none' }}>
            <form class='form-login-1' >
              <label for="username">Số Điện Thoại</label>
              <div class='username'>
                <input type="text" name="userphone" id="userphone" placeholder="" value={userphone}  onChange={(e) => setuserphone(e.target.value)}></input>
                <div class='input-icon'>
                  {isValidPhoneNumber(userphone) ?
                    (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                    :
                    (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                  }
                </div>
              </div>
              <p class='Notification'>{Notificationname}</p>
              <hr></hr>
              <label for="username">Email</label>
              <div class='username'>
                <input type="email" name="email" id="email" placeholder="" value={useremail}  onChange={(e) => setuseremail(e.target.value)}></input>
                <div class='input-icon'>
                  {useremail ?
                    (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                    :
                    (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                  }
                </div>
              </div>
              <p class='Notification'>{Notificationname}</p>
              <div class='line-button'>
                <div class='line'></div>
                <button class='button' onClick={onclickform1}>Tiếp theo</button>
                <div class='line'></div>
              </div>
              <div class='line-button'>
                <div class='line'></div>
                <span>1</span>
                <div class='line'></div>
                <span style={{backgroundColor:"#fff",color:"#FF751A"}}>2</span>
                <div class='line'></div>
                <span>3</span>
                <div class='line'></div>
                <span>4</span>
                <div class='line'></div>
              </div>
            </form>
          </div>
          {/* form-3 */}
          <div style={{ display: form3 ? 'block' : 'none' }}>
            <div class='form-login-1' style={{display:"flex"}}>
              <div class='button-icon'>
                <p>Facebook</p>
              </div>
              <div class='button-icon'>
                <p>Google</p>
              </div>
            </div>
            <div class='form-login-1'>
              <div class='line-button'>
                <div class='line'></div>
                <p style={{margin:"0"}}>Hoặc</p>
                <div class='line'></div>
              </div>
            </div>
            <form class='form-login-1' >
              <label for="username">Tên Người Dùng / Số Điện Thoại</label>
              <div class='username'>
                <input type="text" name="username" id="username" placeholder="" value={username}  onChange={(e) => setusername(e.target.value)}></input>
                <div class='input-icon'>
                  {username ?
                    (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                    :
                    (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                  }
                </div>
              </div>
              <p class='Notification'>{Notificationname}</p>
              <hr></hr>
              <label fr="password">Mật Khẩu</label>
              <div class='password'>
                <input type={showPassword ? "text" : "password"}  name="password"  id="password" placeholder="" value={password} onChange={(e) => setpassword(e.target.value)}></input>
                <div  class='input-icon'onClick={handleTogglePassword}>
                  <FontAwesomeIcon icon={faEyeSlash} class='icon'style={{display: showPassword ? 'block':'none'}}/>
                  <FontAwesomeIcon icon={faEye} class='icon'     style={{display: showPassword ? 'none':'block'}}/>
                </div>
              </div>
              <p class='Notification'>{Notificationpassword}</p>
              <p class='forgot-password'><a href='/'>Quên mật khẩu ?</a></p>
              <div class='line-button'>
                <div class='line'></div>
                <button class='button' onClick={onclickform1}>Đăng nhập</button>
                <div class='line'></div>
              </div>
              <div class='line-button'>
                <div class='line'></div>
                <span>1</span>
                <div class='line'></div>
                <span>2</span>
                <div class='line'></div>
                <span style={{backgroundColor:"#fff",color:"#FF751A"}}>3</span>
                <div class='line'></div>
                <span>4</span>
                <div class='line'></div>
              </div>
            </form>
          </div>
          {/* form-4 */}
          <div style={{ display: form4 ? 'block' : 'none' }}>
            <div class='form-login-1' style={{display:"flex"}}>
              <div class='button-icon'>
                <p>Facebook</p>
              </div>
              <div class='button-icon'>
                <p>Google</p>
              </div>
            </div>
            <div class='form-login-1'>
              <div class='line-button'>
                <div class='line'></div>
                <p style={{margin:"0"}}>Hoặc</p>
                <div class='line'></div>
              </div>
            </div>
            <form class='form-login-1' >
              <label for="username">Tên Người Dùng / Số Điện Thoại</label>
              <div class='username'>
                <input type="text" name="username" id="username" placeholder="" value={username}  onChange={(e) => setusername(e.target.value)}></input>
                <div class='input-icon'>
                  {username ?
                    (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                    :
                    (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                  }
                </div>
              </div>
              <p class='Notification'>{Notificationname}</p>
              <hr></hr>
              <label fr="password">Mật Khẩu</label>
              <div class='password'>
                <input type={showPassword ? "text" : "password"}  name="password"  id="password" placeholder="" value={password} onChange={(e) => setpassword(e.target.value)}></input>
                <div  class='input-icon'onClick={handleTogglePassword}>
                  <FontAwesomeIcon icon={faEyeSlash} class='icon'style={{display: showPassword ? 'block':'none'}}/>
                  <FontAwesomeIcon icon={faEye} class='icon'     style={{display: showPassword ? 'none':'block'}}/>
                </div>
              </div>
              <p class='Notification'>{Notificationpassword}</p>
              <p class='forgot-password'><a href='/'>Quên mật khẩu ?</a></p>
              <div class='line-button'>
                <div class='line'></div>
                <button class='button' >Đăng nhập</button>
                <div class='line'></div>
              </div>
              <div class='line-button'>
                <div class='line'></div>
                <span >1</span>
                <div class='line'></div>
                <span>2</span>
                <div class='line'></div>
                <span>3</span>
                <div class='line'></div>
                <span style={{backgroundColor:"#fff",color:"#FF751A"}}>4</span>
                <div class='line'></div>
              </div>
            </form>
          </div>
        </div>


        <div class='form-logout'>
          <div class='form-introduce'>
            <h1>Chào mừng bạn !</h1>
            <h1>Đã đến với nhà thuốc Phú Sang.</h1>
            <h3>Vui lòng đăng ký để hưởng những đặc quyền dành cho thành viên.</h3>
          </div>
          
        </div>
      </div>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default Logout;
